var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7985 12.5786C25.8107 10.4186 21.9374 3.375 13.4999 3.375C5.06236 3.375 1.18898 10.4186 0.20123 12.5786C0.0686357 12.8681 0 13.1827 0 13.5011C0 13.8195 0.0686357 14.1342 0.20123 14.4236C1.18898 16.5814 5.06236 23.625 13.4999 23.625C21.9374 23.625 25.8107 16.5814 26.7985 14.4214C26.9308 14.1322 26.9993 13.818 26.9993 13.5C26.9993 13.182 26.9308 12.8678 26.7985 12.5786ZM13.4999 20.25C12.1648 20.25 10.8598 19.8541 9.74976 19.1124C8.63972 18.3707 7.77456 17.3165 7.26367 16.0831C6.75278 14.8497 6.6191 13.4925 6.87955 12.1831C7.14 10.8738 7.78288 9.67103 8.72688 8.72703C9.67089 7.78302 10.8736 7.14015 12.183 6.8797C13.4924 6.61925 14.8496 6.75292 16.083 7.26381C17.3164 7.7747 18.3706 8.63987 19.1123 9.7499C19.854 10.8599 20.2499 12.165 20.2499 13.5C20.2481 15.2897 19.5363 17.0055 18.2709 18.271C17.0054 19.5365 15.2895 20.2482 13.4999 20.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C15.9853 18 18 15.9853 18 13.5C18 11.0147 15.9853 9 13.5 9C11.0147 9 9 11.0147 9 13.5C9 15.9853 11.0147 18 13.5 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bf732c2b5fec63c5124deca6f6d2b1fd.svg";
export { ForwardRef as ReactComponent };